import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/solid";
import { Button, Typography } from "@material-tailwind/react";
import { useEffect, useRef, useState } from "react";
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../styles/home.css";
import { GetAllProductsWithImages } from "../../services/ApiServices/ProductService";
import ProductCard from "../ProductCard";
import { Link } from "react-router-dom";
import { FaSpinner } from 'react-icons/fa';


type HomeProps = {
    loading: any,
    setLoading: (loading: boolean) => void
};

function Home({ loading, setLoading }: HomeProps) {
    const [products, setProducts] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');

    const sliderRef = useRef<any>();

    const fetchProducts = async () => {
        let products = null;
        setLoading(true);
        try {
            products = await GetAllProductsWithImages();
            setProducts(products);
        } catch (error: any) {
            if (error.response && error.response.data && error.response.data.message) {
                setErrorMessage(error.response.data.message);
            } else {
                setErrorMessage('An error occurred. Please try again later.');
            }
        } finally {
            setLoading(false);
        }
    };

    const nextSlide = () => {
        sliderRef.current.slickNext();
    };

    const previousSlide = () => {
        sliderRef.current.slickPrev();
    };

    const settings = {
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 8000,
        pauseOnHover: false,
        cssEase: 'linear'
    };

    const settings2 = {
        centerMode: true,
        centerPadding: '0px',
        slidesToShow: 5,
        slidesToScroll: 5,
        infinite: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1
                }
            }
        ]
    };

    useEffect(() => {
        fetchProducts();
    }, []);

    const activeProducts = products.filter((product: any) => product.status === "Active");

    if (products.length === 0) {
        setTimeout(() => {
            setLoading(false);
        }, 3000);

        return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', textAlign: 'center' }}>
                <FaSpinner style={{ fontSize: '48px', color: '#4A90E2', marginBottom: '20px', animation: 'spin 2s linear infinite' }} />
                <h2 style={{ fontWeight: 'bold', fontSize: '24px' }}>Xin lỗi vì sự bất tiện này!</h2>
                <p style={{ fontSize: '18px', color: '#555', margin: '10px 0' }}>
                    Hãy đợi vài giây để chúng tôi tải lại dữ liệu. Nếu vẫn không tải được, vui lòng thử lại.
                </p>
            </div>
        );
    }

    return (
        <>
            {setLoading(false)}

            <div className="relative w-full" style={{ height:"750px",backgroundColor: "#FEFFC4" }}>
                <img src="/carousel.png" alt="Áo dài showcase" className="h-full w-full object-cover" />
                <div className="absolute inset-0 flex items-center justify-center">
                    <div className="text-white text-center w-full md:w-3/4 mx-auto p-8 md:p-12 bg-opacity-60 bg-black rounded-xl shadow-xl">
                        <Typography placeholder={""}
                            variant="h3"
                            className="mb-6 font-bold"
                            style={{ fontFamily: "Noto Serif, serif", fontSize: "1.5rem", lineHeight: "1.6" }}
                        >
                            "Áo dài không chỉ là một bộ trang phục mà còn là cả một câu chuyện.."
                        </Typography>
                        <Link to="/products">
                            <Button placeholder={""}
                                size="lg"
                                style={{
                                    backgroundColor: "#395F18",
                                    color: "#FEFFC4",
                                    transition: "background-color 0.3s ease, transform 0.3s ease",
                                }}
                                className="hover:bg-green-600 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-green-300"
                            >
                                Mua ngay
                            </Button>
                        </Link>
                    </div>
                </div>

            </div>
            <div className="container w-full" style={{ maxWidth: "100%", overflowX: "hidden" }}>
                <Slider {...settings} >
                    <div className="p-3">
                        <img src="/Liudiu.png" />
                    </div>
                    <div className="p-3">
                        <img src="/Liudiu.png" />
                    </div>
                    <div className="p-3">
                        <img src="/Liudiu.png" />
                    </div>
                    <div className="p-3">
                        <img src="/Liudiu.png" />
                    </div>
                    <div className="p-3">
                        <img src="/Liudiu.png" />
                    </div>
                </Slider>
            </div>
            <div className="flex w-full justify-center items-center bg-black h-32">
                <h5 className="text-center text-xl text-white">
                    "Mỗi chiếc áo dài là một bài thơ về người phụ nữ Việt – duyên dáng, thanh lịch và mạnh mẽ."
                </h5>
            </div>
            <div className="featured-products w-full h-full text-center bg-brown-50 my-4 p-4" style={{ height:"800px", overflow: "hidden" }}>
                <Slider {...settings2} slidesToShow={activeProducts.length <= 5 ? 3 : 5} arrows={false} ref={sliderRef}>
                    {activeProducts.map((product: any) => (
                        <div className="w-full mt-10" style={{height: "600px"}}>
                            <ProductCard key={product.id} id={product.id} name={product.name} price={product.price}
                                images={product.productImages} />
                        </div>
                    ))}
                </Slider>
                <div className="w-full flex justify-center gap-4">
                    <Button variant="text" onClick={previousSlide} placeholder={""}>
                        <ArrowLeftIcon className="w-6 h-6" />
                    </Button>
                    <Button variant="text" onClick={nextSlide} placeholder={""}>
                        <ArrowRightIcon className="w-6 h-6" />
                    </Button>
                </div>
            </div>
            <div className="flex flex-wrap w-full h-full my-8 p-4 gap-4" style={{ overflow: "hidden" }}>
                <div className="flex justify-center w-full lg:w-1/2" style={{ minWidth: "300px" }}>
                    <img className="w-2/3" src="/look-fresh.png" />
                </div>
                <div className="w-full lg:w-2/5" style={{ marginTop: "70px" }}>
                    <h3 className="text-5xl font-bold" style={{ marginBottom: "70px" }}> <br />
                        <img src="/quote.svg" />
                    </h3>
                    <p className="text-xl text-black font-normal mb-5">"Khi một người phụ nữ khoác lên mình tà áo dài, cô ấy không chỉ mặc trang phục, mà đang mặc lên mình cả một di sản văn hóa."
                    </p>
                </div>
            </div>
        </>
    );
}

export default Home;
